import { CheckCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { pxToRem } from 'shared/lib/pxToRem';

export const RoleCardStyled = styled.div`
	padding: ${pxToRem(16)};
	width: 100%;
	border: 1px solid #f5f5f5;
	border-radius: 10px;
	background-color: #fafafa;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		padding: ${pxToRem(16)};
	}
`;

export const RoleHeadingStyled = styled.h2<{ inModal: boolean }>`
	margin-bottom: ${pxToRem(12)};
	font-size: ${pxToRem(16)};
	line-height: ${pxToRem(24)};
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: ${props => (props.inModal ? pxToRem(16) : pxToRem(20))};
		margin-bottom: ${props => (props.inModal ? pxToRem(12) : pxToRem(16))};
		line-height: ${props => (props.inModal ? pxToRem(24) : pxToRem(31))};
	}
`;

export const RoleSubheadingStyled = styled.h3`
	margin-bottom: ${pxToRem(12)};
	font-weight: 600;
	font-size: ${pxToRem(14)};
`;

export const RolesFeaturesListStyled = styled.ul`
	gap: ${pxToRem(8)};
	display: flex;
	flex-direction: column;
	padding-left: 18px;
`;

export const RoleFeatureStyled = styled.li`
	gap: ${pxToRem(8)};
	align-items: start;
	font-size: 12px;
`;

export const IconStyled = styled(CheckCircleOutlined)`
	margin-top: 3px;
`;

export const RoleHeadingContainerStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: start;
`;

export const DotStyled = styled.div`
	width: 3px;
	height: 3px;
	border-radius: 50%;
	background-color: #2b2d42;
`;
